import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, List, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import SignUpForm from "./SignUpForm";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { withFirebase } from "../Firebase";
import { blueGrey, grey } from "@material-ui/core/colors";
import moment from "moment";
import * as ROUTES from "../../constants/routes";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import OutOfDate from "./OutOfDate";
import SignOut from "./SignOut";
import SignUpFormLoading from "../SignUpFormLoading";
import NewUserMessageDialog from "./NewUserMessageDialog";

const RescuerSignUp = (props) => {
  const { firebase } = props;
  const { formId } = useParams();
  const history = useHistory();
  const { t, i18n } = useTranslation();

  const [formMetadata, setFormMetadata] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isUSerCreated, setIsUSerCreated] = useState(false);
  const [isSigningUp, setIsSigningUp] = useState(false);
  const [openSignUpModal, setOpenSignUpModal] = useState(false);
  const [onCreateRescuerMessage, setOnCreateRescuerMessage] = useState("");
  const [totalRescuersNumber, setTotalRescuersNumber] = useState(0);
  const [waittingForAccountCompleted, setwaittingForAccountCompleted] = useState(false);

  useEffect(() => {
    firebase
      .rescuersFormsRef(formId)
      .once("value")
      .then((snap) => {
        const data = snap.val();
        if (!data) {
          history.push(ROUTES.SIGN_IN);
        } else {
          setTimeout(() => {
            setIsLoading(false);
            setFormMetadata(data);
            setTotalRescuersNumber(data.formationGroups.map((g) => g.capacity - g.remaining).reduce((pre, current) => pre + current));
            setIsFormOpen(moment(new Date()).isBetween(moment(data.startDay, "DD/MM/yyy"), moment(data.endDay, "DD/MM/yyy")));
          }, 3550);
        }
      });
  }, []);

  const processForm = (formValues) => {
    const { email, surname1, surname2, name, lang, phone, dni, birthday, workshop, password, auth, comunications, OS } = formValues;

    let info = {
      dni: dni,
      autorizacion: auth,
      comunicaciones: comunications,
      email: email,
      name: name,
      surname: surname1,
      secondSurname: surname2,
      birthday: birthday.format("DD/MM/YYYY"),
      phone: phone,
      comunicationsLang: lang,
      OS: OS,
      defaultLang: i18n.language,
    };

    let sgpfc = {
      managerUid: formMetadata.managerUid,
      formId: formId,
      workshop: workshop,
      email: email,
      userType: "volunteer",
      name: `${name} ${surname1}`,
      isSuccessfullyCreated: false,
    };

    firebase
      .signUpUser(email, password)
      .then((UserCredential) => {
        setIsUSerCreated(true);
        UserCredential.user.updateProfile({ displayName: name });
        firebase
          .user(UserCredential.user.uid)
          .update({
            info: info,
            sgpfc: sgpfc,
          })
          .then(() => {
            setIsSigningUp(false);
            setIsUSerCreated(true);
            setOnCreateRescuerMessage({
              msg: "auth/user-success",
              success: true,
            });
            history.push(ROUTES.WAITINGFORCOMPLETEUSERACCOUNT);
          });
      })
      .catch((err) => {
        setIsUSerCreated(true);
        setIsSigningUp(false);
        setOnCreateRescuerMessage({ msg: err.code, success: false });
        setOpenSignUpModal(true);
      });
  };

  if (isLoading) {
    return <SignUpFormLoading />;
  } else if (!!!firebase.currentUser() || isUSerCreated) {
    if (!isFormOpen) {
      return <OutOfDate isAfterToday={moment(formMetadata?.startDay, "DD/MM/yyy").isAfter(moment())} />;
    } else {
      return (
        <Grid container spacing={4} justify="center" style={{ backgroundColor: grey[50] }}>
          <Grid item xs={12} md={10} lg={7} xl={6} style={{ marginTop: 32 }} container justify="center">
            <Grid item xs={12} container justify="center">
              <Typography
                variant="h3"
                color="secondary"
                style={{
                  marginTop: 32,
                  marginBottom: 32,
                  fontWeight: 800,
                  textAlign: "center",
                }}
              >
                {t("totalRescuersSignUp", { n: 238 + totalRescuersNumber })}
              </Typography>
            </Grid>
            <SignUpForm
              formationGroups={formMetadata.formationGroups}
              formName={formMetadata.titles}
              sendformData={processForm}
              isSigningUp={isSigningUp}
              setIsSigningUp={setIsSigningUp}
            />
          </Grid>
          <NewUserMessageDialog
            open={openSignUpModal}
            onCreateRescuerMessage={onCreateRescuerMessage}
            waittingForAccountCompleted={waittingForAccountCompleted}
            setwaittingForAccountCompleted={setwaittingForAccountCompleted}
            setIsSigningUp={setIsSigningUp}
            isSigningUp={isSigningUp}
          />
        </Grid>
      );
    }
  } else {
    return <SignOut />;
  }
};

export default withFirebase(RescuerSignUp);
